import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { FormSpy } from 'react-final-form';
import { Button } from 'antd';
import { omit } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';

export default (options = {}) => WrappedComponent =>
class withFormData extends Component {
    state = {
        viewForm: true,
    }

    componentDidMount = () => {
        const noFromStore = !this.props.match.params.id;
        const storeData = localStorage && localStorage.getItem(options.key);

        if (noFromStore && storeData) {
            try {
                const { languages, organization, kadrsyst, ...data } = JSON.parse(storeData);

                if (notEmpty(data)) {
                    this.setState({
                        dataFromLocalStorage: {
                            languages: languages || [{}],
                            organization,
                            kadrsyst,
                            ...data
                        },
                        viewForm: false,
                    });
                }
            } catch {
                this.setState({
                    dataFromLocalStorage: {},
                    viewForm: true,
                });
            }
        }
    }

    continue = () => {
        this.setState({ viewForm: true });
    }

    new = () => {
        localStorage.removeItem(options.key);

        this.setState({
            dataFromLocalStorage: {},
            viewForm: true,
        });
    }

    clearFormData = () => {
        localStorage.removeItem(options.key);
    }

    formListener = () => (
        <FormSpy
            subscription={{ values : true }}
            onChange={({ values }) => {
                if (localStorage) {
                    const data = omit(['languages', 'organization', 'kadrsyst'], values || {});
                    if (notEmpty(data)) {
                        localStorage.setItem(options.key, JSON.stringify({
                            ...values,
                        }));
                    }
                }
            }}
        />
    )

    renderQuestion = () => {
        const { position } = this.state.dataFromLocalStorage;

        return (
            <div className='request-form-question' >
                <div className='request-form-text'>
                    <Translate content='requestContinueQuestion.question' with={{ position }} />
                </div>
                <div className='request-form-buttons'>
                    <Button
                        className='request-form-continue-button'
                        type='primary'
                        onClick={this.continue}
                    >
                        <Translate content='requestContinueQuestion.continue' />
                    </Button>
                    <Button
                        className='request-form-new-button'
                        onClick={this.new}
                    >
                        <Translate content='requestContinueQuestion.new' />
                    </Button>
                </div>
            </div>
        );
    }

    render () {
        const viewForm = this.state.viewForm;
        const data = this.state.dataFromLocalStorage;

        return !viewForm ? this.renderQuestion() : (
            <WrappedComponent
                clearFormData={this.clearFormData}
                formListener={this.formListener}
                initialValues={data}
                {...this.props}
            />
        );
    }
};
